import React, { useState } from 'react';
import { formatLabelNumber, parseLabelNumber } from '../utils/labelNumber';
import '../GetLabelsPage.css';

// "Replacement Label" section: re-print one label with a number typed by hand
// (for labels that peeled off). No counter is touched.
//   generate(n, product, unitsPerBox) → the same jsPDF the tab makes for that number
//   products (optional) → adds a product select + units/box field for box labels
const ReplacementLabel = ({ numberLabel, products, unitsKey, fileName, generate }) => {
  const [code,  setCode]  = useState('');
  const [sku,   setSku]   = useState('');
  const [units, setUnits] = useState('');
  const [file,  setFile]  = useState(null);
  const [error, setError] = useState('');
  const [busy,  setBusy]  = useState(false);

  const n           = parseLabelNumber(code);
  const product     = products?.find((p) => p.SKU === sku);
  const unitsPerBox = parseInt(units) || product?.[unitsKey] || 1;
  const ready       = !!n && (!products || !!product);

  const handleGenerate = async () => {
    setBusy(true);
    setError('');
    setFile(null);
    try {
      const pdf = await generate(n, product, unitsPerBox);
      setFile({ blob: pdf.output('blob'), name: fileName(formatLabelNumber(n), product) });
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setBusy(false);
    }
  };

  const download = () => {
    const url = URL.createObjectURL(file.blob);
    const a   = document.createElement('a');
    a.href = url; a.download = `${file.name}.pdf`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="gl-divider" style={{ margin: '32px 0 28px' }}>Replacement Label</div>

      {error && <div className="gl-error">{error}</div>}

      {products && (
        <div className="gl-brand-wrap">
          <label className="gl-label">Product</label>
          <select className="gl-select" value={sku}
            onChange={(e) => { setSku(e.target.value); setUnits(''); setFile(null); }}>
            <option value="">{products.length ? '— Select product —' : '— Select a brand above —'}</option>
            {products.map((p) => <option key={p.SKU} value={p.SKU}>{p.name} — {p.SKU}</option>)}
          </select>
        </div>
      )}

      <div className="gl-seed-qty-row">
        <div className="gl-qty-field">
          <label className="gl-label">{numberLabel}</label>
          <input type="text" className="gl-input-lg" value={code} placeholder="A0123"
            onChange={(e) => { setCode(e.target.value); setFile(null); }} />
        </div>
        {products && (
          <div className="gl-qty-field">
            <label className="gl-label">Units / Box</label>
            <input type="number" min="1" className="gl-input-lg" value={units}
              placeholder={product?.[unitsKey] ?? 1}
              onChange={(e) => { setUnits(e.target.value); setFile(null); }} />
          </div>
        )}
        {!file && (
          <button className="gl-btn gl-btn-primary" onClick={handleGenerate} disabled={busy || !ready}>
            {busy ? 'Generating…' : `Generate ${n ? formatLabelNumber(n) : 'Label'}`}
          </button>
        )}
        {file && (
          <>
            <button className="gl-btn gl-btn-primary" onClick={download}>Download PDF</button>
            <button className="gl-btn gl-btn-gray" onClick={() => setFile(null)}>New</button>
          </>
        )}
      </div>
    </>
  );
};

export default ReplacementLabel;
